export const handleError = (error: any) => {
  console.error('An error occurred:', error);
  // Ajoutez ici toute autre gestion d'erreur spécifique
};
